var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { v4 as uuidV4 } from 'uuid';
var ArrowDropDown = React.forwardRef(function (props, ref) {
    var className = props.className, fill = props.fill;
    var id = useState(uuidV4().replace(/-/g, ''))[0];
    return (_jsx("svg", __assign({ className: className, ref: ref, xmlns: "http://www.w3.org/2000/svg", width: "17", height: "16", viewBox: "0 0 17 16", fill: "none" }, { children: _jsx("path", { id: id, d: "M4.65546 6.99415L8.12724 10.8294C8.33311 11.0569 8.66689 11.0569 8.87276 10.8294L12.3445 6.99415C12.6766 6.62728 12.4414 6 11.9718 6H5.02822C4.55857 6 4.32337 6.62728 4.65546 6.99415Z", fill: fill !== null && fill !== void 0 ? fill : '#E14436' }) })));
});
export default ArrowDropDown;
